import BaseComponent from '../../BaseComponent';

export default class BulkEmailForm extends BaseComponent {
    private rcptTypesMap: Record<string, string[]> = {};
    private $warning: JQuery;
    private $btnGroup: JQuery;
    private $recipientSelection: JQuery;

    public init (): void {
        this.$btnGroup = this.$component.find('[data-rcpt-types-map]');
        this.$warning = this.$component.find('.bulk-email-select-type-warning');
        this.$recipientSelection = this.$component.find('#recipientSelection');

        this.rcptTypesMap = this.$btnGroup.data('rcpt-types-map') || {};

        const $typeSelect = this.$component.find('select[name="type"]');
        this.initSelect($typeSelect);

        // Apply initial state
        const initialType = $typeSelect.val() as string;
        this.toggleRecipientArea(initialType);
        if (initialType) {
            this.filterRecipientTypes(initialType);
        }
    }

    public initSelect (selectElement): void {
        const that = this;
        selectElement.on('change', function () {
            const selectedType = $(this).val() as string;
            that.processSelectType(selectedType);
            that.toggleRecipientArea(selectedType);
            if (selectedType) {
                that.resetRecipientSelection();
                that.filterRecipientTypes(selectedType);
                // Show recipient selection after filter selects the first radio
                // (Nette toggle will have shown the correct child panel)
                that.$recipientSelection.show();
            }
        });
    }

    /**
     * Show warning when no email type is selected, show buttons otherwise.
     * Uses jQuery show/hide to toggle visibility of the recipient selection area.
     */
    private toggleRecipientArea(emailType: string): void {
        if (!emailType) {
            // No type selected — show warning, hide buttons and selection
            this.$warning.show();
            this.$btnGroup.hide();
            this.$recipientSelection.hide();
        } else {
            // Type selected — hide warning, show buttons and selection area
            this.$warning.hide();
            this.$btnGroup.show();
            this.$recipientSelection.show();
        }
    }

    /**
     * Reset all recipient selections (uncheck checkboxes, hide selection panels).
     */
    private resetRecipientSelection(): void {
        // Uncheck all recipient type radio buttons
        this.$component.find('input[data-recipient-type]').prop('checked', false);

        // Uncheck all recipient checkboxes in selection panels
        this.$recipientSelection.find('input[type="checkbox"]').prop('checked', false);

        // Hide the recipient selection area
        this.$recipientSelection.hide();

        // Hide all individual selection panels within recipientSelection
        this.$recipientSelection.children().hide();
    }

    private filterRecipientTypes(emailType: string): void {
        const allowed = this.rcptTypesMap[emailType] || null;
        const $items = this.$component.find('[data-recipient-type]');

        $items.each((_i, el) => {
            const $el = $(el);
            const type = $el.attr('data-recipient-type');

            if (!allowed) {
                // No mapping for this email type — show all
                $el.show();
            } else if (allowed.includes(type)) {
                $el.show();
            } else {
                $el.hide();
                // If the hidden input was checked, uncheck and select first visible
                if ($el.is('input:checked')) {
                    $el.prop('checked', false);
                }
            }
        });

        // If the currently checked radio was hidden, select the first visible one
        if (allowed && !this.$component.find('input[data-recipient-type]:visible:checked').length) {
            this.$component.find('input[data-recipient-type]:visible')
                .first()
                .prop('checked', true)
                .trigger('change');
        }
    }

    public processSelectType (templateType): void {
        this.$component.find('input, textarea').each( (i, input) => {
            const $input = $(input);

            // default value
            const value = $input.data('emailform-' + templateType + '-value');
            if (typeof value === 'string') {
                $input.val(value)
                window.ckeditors?.[$input.attr('id')]?.setData(value);
            }

            // placeholder
            const placeholder = $input.data('emailform-' + templateType + '-placeholder');
            if (typeof placeholder === 'string') {
                $input.attr('placeholder', placeholder);
            }
        });
    }
}
